import PropTypes from "prop-types";
import "./style.scss";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";

const getButtonText = (text) => {
  return typeof text === "function" ? text() : text;
};

const getEnabledState = (enabled) => {
  return typeof enabled === "function" ? enabled() : enabled;
};

const getWidth = (size) => {
  switch (size) {
    case "small":
      return "calc(75% + 10px)";
    case "large":
      return "100%";
    default:
      return "100%";
  }
};

const themeStyle = (theme, enabled, variant) => {
  const { buttons } = theme;

  switch (variant) {
    case "outlined":
      return {
        backgroundColor: "transparent",
        color: buttons.color,
        border: `2px solid ${buttons.backgroundColor}`,
      };
    case "whatsapp":
      return {
        backgroundColor: "#FFFFFF",
        color: buttons.backgroundColor,
        border: "none",
      };
    default:
      if (!enabled) {
        return {
          backgroundColor: `${buttons.backgroundColor}33`,
          color: `${buttons.color}33`,
          border: "none",
        };
      }
      return {
        backgroundColor: buttons.backgroundColor,
        color: buttons.color,
        border: "none",
      };
  }
};

const BotButton = ({
  variant = "default",
  text = "Button",
  size = "large",
  enabled = false,
  onClick = () => {},
  style = {},
  className = "",
  startIcon = null,
}) => {
  const { theme } = useInitialConfigStore((state) => state);

  return (
    <button
      onClick={() => onClick()}
      className={`button ${className}`}
      style={{
        backgroundColor: themeStyle(theme, enabled, variant).backgroundColor,
        color: themeStyle(theme, enabled, variant).color,
        border: themeStyle(theme, enabled, variant).border,
        pointerEvents: getEnabledState(enabled) ? "auto" : "none",
        width: getWidth(size),
        ...style,
      }}
    >
      {startIcon && <span className="button-icon">{startIcon}</span>}
      <span>{getButtonText(text)}</span>
    </button>
  );
};

BotButton.propTypes = {
  variant: PropTypes.oneOf(["default", "outlined", "whatsapp"]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  size: PropTypes.oneOf(["small", "large"]),
  enabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  onClick: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string,
  startIcon: PropTypes.node,
};

export default BotButton;
